import * as actionTypes from './types';
import { indexTree } from './treeUtils';

const INITIAL_STATE = {
  tree: null, // nested TreeNode[], or null before the first fetch
  index: {}, // every node by id, derived from tree
  loading: false,
  error: false
};

const contextReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_TREE_LOADING:
      return { ...state, loading: true, error: false };
    case actionTypes.FETCH_TREE_SUCCESS:
      return {
        ...state,
        tree: action.payload.tree,
        index: indexTree(action.payload.tree),
        loading: false,
        error: false
      };
    case actionTypes.FETCH_TREE_FAILED:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};

export default contextReducer;
